import { createI18n } from 'vue-i18n';

/* TRANSLATIONS */
import en from '@/locales/en';

const i18n = createI18n({
  locale: 'en',
  messages: {
    en,
  },
});

export default i18n;
